import ko from './ko-KR';
import en from './en-US';
import zh from './zh-CN';

export const langAll = ['ko-KR', 'en-US', 'zh-CN'];
export const langWord = {
  'ko-KR':'한국어',
  'en-US':'English',
  'zh-CN':'简体中文'
};

export default {
  'ko-KR': ko,
  'en-US': en,
  'zh-CN': zh,
};


// WEBPACK FOOTER //
// ./src/locales/index.ts